module.exports = __webpack_public_path__ + "78c8969a8ba3e8c76ad22a32c206c2ad.pdf";